import React from '../../_snowpack/pkg/react.js';
import styled, { css } from '../../_snowpack/pkg/styled-components.js';
import { GrowlScene } from '../../_snowpack/pkg/@crystallize/react-growl.js';
const StyledWrapper = styled.div.withConfig({
  displayName: "growl-wrapper__StyledWrapper",
  componentId: "sc-1nedh46-0"
})(({
  theme
}) => css([".crystallize-growl{z-index:", ";}.crystallize-growl__item{padding-right:40px;&-text{font-size:12px;margin-top:0;}&-title{font-family:'Roboto Slab',sans-serif;font-size:16px;margin:0 0 2px;}}"], theme.zIndex.growl));
export function GrowlWrapper() {
  return /*#__PURE__*/React.createElement(StyledWrapper, null, /*#__PURE__*/React.createElement(GrowlScene, null));
}